













































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import ModalAddFolder from '@/components/Modal/ModalAddFolder.vue'
import ModalMoveToFolder from '@/components/Modal/ModalMoveToFolder.vue'
import ModalEditFolder from '@/components/Modal/ModalEditFolder.vue'
import ListTopic from '@/views/Group/TopPage/NewFeed/ListTopic.vue'
import MobileButtonArea from '@/views/Group/TopPage/NewFeed/Layout/MobileButtonArea.vue'
import PcButtonArea from '@/views/Group/TopPage/NewFeed/Layout/PcButtonArea.vue'
import SidebarPc from '@/views/Group/TopPage/NewFeed/Layout/SidebarPc.vue'
import {
  EFolderItemCountType,
  EFolderType,
  IFolderItemCount,
  MoveToUnclsFrom,
  TopicCompact,
  TopicFolder
} from '@/models'
import CommonTopicService from '@/services/CommonTopicService'
import GroupTopicService from '@/services/GroupTopicService'
import GroupService from '@/services/GroupService'
import { EListSort } from '@/models/Setting/Enum'
import store from '@/store'
import Setting from '@/store/modules/Setting'
import { getModule } from 'vuex-module-decorators'
import UserService from '@/services/UserService'
import { PINNED_ITEM, PIN_TYPE } from '@/models/Common/Pinned'
const SettingModule = getModule(Setting, store)
//@ts-ignore
import _ from 'lodash'
import { ERR_API_KEY } from '@/constants'

/**
 * f2-401
 * f2-701
 * f2-401b1
 * グループ掲示板TOP
 * 共通トピックTOP
 * グループ掲示板 - ゴミ箱
 */
@Component({
  components: {
    MobileButtonArea,
    PcButtonArea,
    SidebarPc,
    ListTopic,
    ModalAddFolder,
    ModalMoveToFolder,
    ModalEditFolder
  }
})
export default class NewFeedLayout extends Vue {
  isCommonTopic = !this.$route.params.groupId
  roleEditTopic: boolean = false
  // NWS-1831 掲示板の削除権限（グループ管理者のみ）
  roleDeleteTopic: boolean = false
  title: string = this.$t('groups.new_feed.title') as string
  sortSelected: any = {}
  sortOptions: IDropDown[] = []
  allFolder: TopicFolder[] = []
  folderSelected: any = {
    text: `${this.$t('groups.all')}`,
    suffix: ' (0)'
  }
  folderEdit: any = {}
  folderOptions: IDropDown[] = []
  checkAll: boolean = false
  isSelectAnyItem: boolean = false
  actionAreaState: EState = EState.ALL
  modalMess: string = ''
  private isDeleteAllBin: boolean = false
  eState = EState
  private limit: number = this.$store.state.setting.setting.setting_display
    .number_item_lists
  private folderItemCount: IFolderItemCount[] = []
  private from: string = "Topic List"

  // unpin params
  topics: TopicCompactViewModel[] = []
  page: number = 1
  startLoading: boolean = true
  maxPage: number = 1

  openEditFolderModal(index?: number) {
    this.folderEdit = index ? this.folderOptions[index] : this.folderSelected
    this.$bvModal.show('edit-folder')
  }


  created() {
    this.initSortDropdown()
    this.initFolder()
    this.handleRoleEditTopic()
  }

  @Watch('sortSelected')
  @Watch('folderSelected')
  async init() {
    this.page = 1
    this.topics = []
    if (this.isCommonTopic) {
      SettingModule.CHANGE_SORT_COMMON_TOPIC(this.sortSelected.id)
      if (this.sortSelected.id !== undefined) {
        await this.getCommonTopic()
        this.title = this.$t('groups.new_feed.title') as string
      }
    } else {
      SettingModule.CHANGE_SORT_GROUP_TOPIC(this.sortSelected.id)
      if (
        this.folderSelected.id !== undefined &&
        this.sortSelected.id !== undefined
      ) {
        this.checkAll = false
        this.isSelectAnyItem = false
        this.checkAll = false
        switch (this.folderSelected.id) {
          case 0:
            this.actionAreaState = EState.ALL
            await this.getTopics()
            this.title = this.$t('groups.new_feed.title') as string
            this.$router.replace({ query: { folder: 'all' } }).catch(() => {})
            break
          case 1:
            this.actionAreaState = EState.ALL
            await this.getTopicUnclassified()
            this.title = this.$t('groups.new_feed.title') as string
            this.$router
              .replace({ query: { folder: 'unclassified' } })
              .catch(() => {})
            break
          case 2:
            this.actionAreaState = EState.BIN
            this.allTopicDeleted()
            this.title = this.$t('groups.bin') as string
            this.$router.replace({ query: { folder: 'bin' } }).catch(() => {})
            break
          case 3:
            this.actionAreaState = EState.DRAFT
            await this.getDraftTopic()
            this.title = this.$t('groups.draft') as string
            this.$router.replace({ query: { folder: 'draft' } }).catch(() => {})
            break
          default:
            this.actionAreaState = EState.FOLDER
            await this.getTopicByFolder()
            this.title = this.folderSelected.text
            this.$router
              .replace({
                query: {
                  folder: `${this.folderSelected.value.id}`
                }
              })
              .catch(() => {})
            break
        }
      }
    }
  }

  @Watch('$store.state.userInfo.user.group_role')
  @Watch('$store.state.userInfo.user.common_topic_role')
  handleRoleEditTopic() {
    if (this.isCommonTopic) {
      this.roleEditTopic = this.$store.state.userInfo.user.common_topic_role
      this.roleDeleteTopic = this.$store.state.userInfo.user.common_topic_role
    } else {
      this.roleEditTopic = this.$store.state.userInfo.user.group_role.role_edit_topic
      // NWS-1831 削除はグループ管理者のみ
      this.roleDeleteTopic = this.$store.state.userInfo.user.group_role.role_admin
    }
  }

  async getTopicFolderItemCount() {
    return GroupTopicService.getTopicFolderItemCount(this.$route.params.groupId)
      .then(res => {
        if (res.status === 200) {
          this.folderItemCount = res.data
        }
      })
      .catch(err => {
        this.modalMess = this.$t('common.message.uncatch_error') as string
        this.$bvModal.show('modal-error')
      })
  }

  private async fetchTopics({
    apiFunc,
    dataSearch,
    loadMore = false,
    onError,
  }: {
    apiFunc: (data: any) => Promise<any>
    dataSearch: any
    loadMore?: boolean
    onError?: (err: any) => void
  }) {
    this.startLoading = true
    try {
      let defaultParams = {
        orderBy: this.sortSelected.value.order_by,
        sortedBy: this.sortSelected.value.sorted_by,
        limit: this.limit,
        page: this.page,
      }
      const res = await apiFunc({ ...defaultParams, ...dataSearch })
      if (res.status === 200) {
        const mapped = res.data.data.map(
          (item: any) => new TopicCompactViewModel(item, 'text-line-clamp-2')
        )
        this.topics = loadMore ? [...this.topics, ...mapped] : mapped
        this.maxPage = res.data.last_page
      }
    } catch (err) {
      if (onError) {
        onError(err)
      } else {
        this.modalMess = this.$t('common.message.uncatch_error') as string
        this.$bvModal.show('modal-error')
      }
    } finally {
      this.startLoading = false
    }
  }

  /**
   * Call API for topics that not detele
   */
  private async getTopics(loadMore?: boolean) {
    let dataSearch = {
      group_id: this.$route.params.groupId
    }

    await this.fetchTopics({
      apiFunc: GroupTopicService.getAllTopicNotDelete,
      dataSearch,
      loadMore
    })
  }

  /**
   * Call API for topics of unclassified
   */
  private async getTopicUnclassified(loadMore?: boolean) {
    let dataSearch = {
      group_id: this.$route.params.groupId
    }

    await this.fetchTopics({
      apiFunc: GroupTopicService.getAllTopicUnclassified,
      dataSearch,
      loadMore
    })
  }

  /**
   * Call API for topics in future
   */
  private async getDraftTopic(loadMore?: boolean) {
    if (this.roleEditTopic) {
      let dataSearch = {
        group_id: this.$route.params.groupId
      }

      await this.fetchTopics({
        apiFunc: GroupTopicService.getAllDraftTopic,
        dataSearch,
        loadMore
      })
    }
  }

  /**
   * Call API for topics by folder
   */
  private async getTopicByFolder(loadMore?: boolean) {
    if (!this.isCommonTopic) {
      let dataSearch = {
        group_id: this.$route.params.groupId,
        folder_id: this.folderSelected.value.id
      }

      await this.fetchTopics({
        apiFunc: GroupTopicService.getAllTopicByFolder,
        dataSearch,
        loadMore,
        onError: err => {
          if (
            err.response.status === 404 &&
            err.response.data.message === ERR_API_KEY.FOLDER_NOT_FOUND
          ) {
            this.modalMess = this.$t(
              'common.message.FOLDER_NOT_EXIST'
            ) as string
            this.$bvModal.show('modal-error')
            this.initFolder()
          } else {
            this.modalMess = this.$t('common.message.uncatch_error') as string
            this.$bvModal.show('modal-error')
          }
        }
      })
    }
  }

  /**
   * Get API for common topics
   */
  private async getCommonTopic(loadMore?: boolean) {
    let dataSearch = {
      unread_only: '0'
    }

    await this.fetchTopics({
      apiFunc: CommonTopicService.getAllCommonTopic,
      dataSearch,
      loadMore
    })
  }

  /**
   * Call API for topics deleted
   */
  allTopicDeleted(loadMore?: boolean) {
    if (this.roleEditTopic) {
      this.startLoading = true
      GroupTopicService.getAllTopicDeleted({
        group_id: this.$route.params.groupId,
        orderBy: this.sortSelected.value.order_by,
        sortedBy: this.sortSelected.value.sorted_by,
        page: this.page,
        limit: this.limit
      })
        .then(res => {
          if (res.status === 200) {
            if (loadMore) {
              this.topics = [
                ...this.topics,
                ...res.data.data.map(
                  (item: any) =>
                    new TopicCompactViewModel(item, 'text-line-clamp-2')
                )
              ]
            } else {
              this.topics = res.data.data.map(
                (item: any) =>
                  new TopicCompactViewModel(item, 'text-line-clamp-2')
              )
            }
            this.maxPage = res.data.last_page
          }
        })
        .catch(err => {
          this.modalMess = this.$t('common.message.uncatch_error') as string
          this.$bvModal.show('modal-error')
        })
        .finally(() => {
          this.startLoading = false
        })
    }
  }

  /**
   * Call API for loadmore
   */
  async loadMore() {
    ++this.page
    if (this.topics.some(topic => topic.checked)) {
      this.checkAll = false
    }
    if (this.isCommonTopic) {
      this.getCommonTopic(true)
    } else {
      switch (this.folderSelected.id) {
        case 0:
          this.getTopics(true)
          break
        case 1:
          this.getTopicUnclassified(true)
          break
        case 2:
          this.allTopicDeleted(true)
          break
        case 3:
          this.getDraftTopic(true)
          break
        default:
          this.getTopicByFolder(true)
          break
      }
    }
  }

  /**
   * Init sort dropdown
   */
  initSortDropdown() {
    const data = [
      {
        id: EListSort.UPDATE_DESC,
        value: {
          order_by: 'updated_at',
          sorted_by: 'desc'
        },
        text:
          this.$t('common.dropdown_sort.sort_date_time') +
          '' +
          this.$t('common.dropdown_sort.desc')
      },
      {
        id: EListSort.UPDATE_ASC,
        value: {
          order_by: 'updated_at',
          sorted_by: 'asc'
        },
        text:
          this.$t('common.dropdown_sort.sort_date_time') +
          '' +
          this.$t('common.dropdown_sort.asc')
      },
      {
        id: EListSort.TITLE_DESC,
        value: {
          order_by: 'title',
          sorted_by: 'desc'
        },
        text:
          this.$t('common.dropdown_sort.sort_title_name') +
          '' +
          this.$t('common.dropdown_sort.desc')
      },
      {
        id: EListSort.TITLE_ASC,
        value: {
          order_by: 'title',
          sorted_by: 'asc'
        },
        text:
          this.$t('common.dropdown_sort.sort_title_name') +
          '' +
          this.$t('common.dropdown_sort.asc')
      }
    ]
    this.sortOptions = data
    if (this.isCommonTopic) {
      this.sortSelected = data[this.$store.state.setting.user_sort.common_topic]
    } else {
      this.sortSelected = data[this.$store.state.setting.user_sort.group_topic]
    }
  }

  /**
   * Get count item for each folder
   */
  getCount(type: EFolderItemCountType, folderId?: number) {
    const item = this.folderItemCount.find(
      item =>
        item.type === type && (folderId ? item.folder_id === folderId : true)
    )
    return item && item.count ? item.count : 0
  }

  /**
   * Init folder dropdown
   */
  async initFolder() {
    if (!this.isCommonTopic) {
      await this.getTopicFolderItemCount()
      GroupTopicService.getAllFolder(this.$route.params.groupId)
        .then(res => {
          if (res.status === 200) {
            this.allFolder = res.data
            let defaultOptions = [
              {
                id: 0,
                value: 0,
                text: `${this.$t('groups.all')}`,
                suffix: ` (${this.getCount(EFolderItemCountType.ALL)})`
              },
              {
                id: 1,
                value: 1,
                text: `${this.$t('groups.unclassified')}`,
                suffix: ` (${this.getCount(EFolderItemCountType.UNCLASSIFIED)})`
              }
            ]

            //add bin if current user is have role
            if (this.roleEditTopic) {
              defaultOptions.push({
                id: 2,
                value: 2,
                text: `${this.$t('groups.bin')}`,
                suffix: ` (${this.getCount(EFolderItemCountType.IN_BIN)})`
              })
              defaultOptions.push({
                id: 3,
                value: 3,
                text: `${this.$t('groups.draft')}`,
                suffix: ` (${this.getCount(EFolderItemCountType.DRAFT)})`
              })
            }

            const folders = res.data.map((item: TopicFolder, index: number) => {
              return {
                id: index + 4,
                value: item,
                text: `${item.name}`,
                suffix: ` (${this.getCount(
                  EFolderItemCountType.FOLDER,
                  item.id
                )})`
              }
            })
            const mergeDatas = [...defaultOptions, ...folders]
            this.folderOptions = mergeDatas
            this.handleFolderSelected()
          }
        })
        .catch(err => {
          this.modalMess = this.$t('common.message.uncatch_error') as string
          this.$bvModal.show('modal-error')
        })
    }
  }

  /**
   * Hanlde folder selected by query folder
   */
  handleFolderSelected() {
    if (this.$route.query.folder) {
      switch (this.$route.query.folder) {
        case 'all':
          this.folderSelected = this.folderOptions[0]
          break
        case 'unclassified':
          this.folderSelected = this.folderOptions[1]
          break
        case 'bin':
          this.folderSelected = this.folderOptions[2]
          break
        case 'draft':
          this.folderSelected = this.folderOptions[3]
          break
        default:
          //get current selected folder id
          const folderSelectedId = Number(this.$route.query.folder)

          //if current selected folder id exist
          if (folderSelectedId) {
            const newFolderSelected = this.folderOptions.find(
              item => item.value.id === folderSelectedId
            )
            if (newFolderSelected) {
              this.folderSelected = newFolderSelected
            } else {
              this.folderSelected = this.folderOptions[0]
            }

            //if current selected folder id not exist
          } else {
            this.folderSelected = this.folderSelected.value
              ? this.folderOptions[this.folderSelected.value]
              : this.folderOptions[0]
          }
      }
    } else {
      this.folderSelected = this.folderOptions[0]
      this.$router.replace({ query: { folder: 'all' } }).catch(() => {})
    }
  }

  /**
   * Handle checkbox check all
   */
  handleCheckAll(checkAll: boolean) {
    this.checkAll = checkAll

    if (checkAll) {
      const hasChecked = this.topics.some(item => item.checked)

      if (!hasChecked) {
        const hasUnpinned = this.topics.some(item => !item.is_pin)
        this.topics.forEach(item => {
          if (hasUnpinned ? !item.is_pin : item.is_pin) {
            item.checked = true
          }
        })
      } else {
        const hasPinnedChecked = this.topics.some(
          item => item.is_pin && item.checked
        )
        const hasUnpinnedChecked = this.topics.some(
          item => !item.is_pin && item.checked
        )

        this.topics.forEach(item => {
          if (hasPinnedChecked && item.is_pin) item.checked = true
          if (hasUnpinnedChecked && !item.is_pin) item.checked = true
        })
      }

      this.hanldeSelectAnyItem(true)
    } else {
      this.topics.forEach(item => (item.checked = false))
      this.hanldeSelectAnyItem(false)
    }
  }

  /**
   * Handle is any checkbox is check
   */
  hanldeSelectAnyItem(isSelect: boolean) {
    this.isSelectAnyItem = isSelect
  }

  /**
   * Handle move topic from unclassified to selected folder
   * Call API move to selected folder
   */
  handleMoveToUnclassified(isFromBin: boolean) {
    if (this.roleEditTopic && this.isSelectAnyItem) {
      this.$blockui.show()
      GroupTopicService.moveTopicsToUnclassified(
        this.$route.params.groupId,
        this.getSelectedTopicId(),
        isFromBin ? MoveToUnclsFrom.BIN : MoveToUnclsFrom.FOLDER
      )
        .then(res => {
          if (res.status === 200) {
            const newList = this.topics.filter(
              file => !this.getSelectedTopicId().includes(file.id)
            )
            this.topics = [...newList]
            this.isSelectAnyItem = false
            this.checkAll = false
            this.initFolder()
          }
        })
        .catch(error => {
          this.modalMess = this.$t('common.message.file_not_exist') as string
          this.$bvModal.show('modal-error')
          this.initFolder()
        })
        .finally(() => this.$blockui.hide())
    }
  }

  /**
   * Handle move topic from unclassified to selected folder
   * Call API move to selected folder
   */
  async handleMoveToFolder(selectedFolder: TopicFolder) {
    if (this.roleEditTopic && this.isSelectAnyItem) {
      this.$blockui.show()
      GroupTopicService.moveTopicsToFolder({
        group_id: this.$route.params.groupId,
        topic_ids: this.getSelectedTopicId(),
        folder_id: selectedFolder.id
      })
        .then(res => {
          if (res.status === 200) {
            if (this.folderSelected.value !== 0) {
              const newList = this.topics.filter(
                file => !this.getSelectedTopicId().includes(file.id)
              )
              this.topics = [...newList]
            } else {
              this.topics.forEach(item => (item.checked = false))
            }
            this.isSelectAnyItem = false
            this.checkAll = false
            this.initFolder()
          }
        })
        .catch(async err => {
          if (err.response.status === 404) {
            if (err.response.data.message === ERR_API_KEY.TOPIC_NOT_FOUND) {
              this.modalMess = this.$t(
                'common.message.topic_not_exist'
              ) as string
              await this.getTopics()
            } else if (err.response.data.message === ERR_API_KEY.FOLDER_NOT_EXIST) {
              this.modalMess = this.$t(
                'common.message.FOLDER_NOT_EXIST'
              ) as string
              this.initFolder()
            } else {
              this.modalMess = this.$t('common.message.uncatch_error') as string
            }
          } else {
            this.modalMess = this.$t('common.message.uncatch_error') as string
          }
          this.$bvModal.show('modal-error')
        })
        .finally(() => this.$blockui.hide())
    }
  }

  /**
   * Jump to create new topic page
   */
  jumpToCreateTopicPage() {
    if (this.isCommonTopic) {
      this.$router.push({ name: 'common-topic-new-feed-topic-create' })
    } else {
      this.$router.push({ name: 'group-new-feed-topic-create' })
    }
  }

  routerCreateTopicPage() {
    if (this.isCommonTopic) {
      return { name: 'common-topic-new-feed-topic-create' }
    } else {
      return { name: 'group-new-feed-topic-create' }
    }
  }

  /**
   * Handle select sort
   */
  handleSortChange(index: number) {
    this.sortSelected = this.sortOptions[index]
  }

  /**
   * Handle delete topics
   * Call API delete topics
   */
  handleMoveTopicToBin() {
    // NWS-1831 削除はグループ管理者のみ
    if (this.roleDeleteTopic && this.isSelectAnyItem) {
      this.$blockui.show()
      GroupTopicService.moveTopicsToBin(
        this.$route.params.groupId,
        this.getSelectedTopicId(),
        this.from
      )
        .then(res => {
          if (res.status === 200) {
            const newList = this.topics.filter(
              file => !this.getSelectedTopicId().includes(file.id)
            )
            this.topics = [...newList]
            this.isSelectAnyItem = false
            this.checkAll = false
            this.modalMess = this.$t('common.message.deleted') as string
            this.$bvModal.show('modal-success')
            this.initFolder()
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.modalMess = this.$t('common.message.topic_not_exist') as string
            this.allTopicDeleted()
          } else {
            this.modalMess = this.$t('common.message.delete_fail') as string
          }
          this.$bvModal.show('modal-error')
        })
        .finally(() => this.$blockui.hide())
    }
  }

  /**
   * open modal confirm for delete topics in bin
   */
  openConfirmDeleteBin(isEmptyBin: boolean) {
    if (isEmptyBin) {
      this.modalMess = this.$t('common.message.delete_all') as string
    } else {
      this.modalMess = this.$t('common.message.delete') as string
    }
    this.isDeleteAllBin = isEmptyBin
    this.$bvModal.show('modal-confirm')
  }

  /**
   * Handle delete topics in bin
   *
   * if (isDeleteAllBin === true)
   * Call API empty bin
   *
   * else
   * Call API delete topics in bin
   *
   */
  handleDeleteBin() {
    // NWS-1831 ゴミ箱からの完全削除／ゴミ箱を空にする操作もグループ管理者のみ
    if (this.roleDeleteTopic) {
      this.$blockui.show()
      if (this.isDeleteAllBin) {
        GroupTopicService.emptyBin(Number(this.$route.params.groupId))
          .then(res => {
            if (res.status === 200) {
              this.topics = []
              this.modalMess = this.$t('common.message.deleted') as string
              this.$bvModal.show('modal-success')
              this.initFolder()
            }
          })
          .catch(() => {
            this.modalMess = this.$t('common.message.delete_fail') as string
            this.$bvModal.show('modal-error')
          })
          .finally(() => this.$blockui.hide())
      } else {
        GroupTopicService.deleteTopicsInBin(
          this.$route.params.groupId,
          this.getSelectedTopicId()
        )
          .then(res => {
            if (res.status === 200) {
              const newList = this.topics.filter(
                file => !this.getSelectedTopicId().includes(file.id)
              )
              this.topics = [...newList]
              this.isSelectAnyItem = false
              this.checkAll = false

              this.modalMess = this.$t('common.message.deleted') as string
              this.$bvModal.show('modal-success')
              this.initFolder()
            }
          })
          .catch(() => {
            this.modalMess = this.$t('common.message.delete_fail') as string
            this.$bvModal.show('modal-error')
          })
          .finally(() => this.$blockui.hide())
      }
    }
  }

  /**
   * Handle create new folder
   * Call API create new folder
   */
  handleAddFolder(newName: string) {
    if (this.roleEditTopic) {
      this.$blockui.show()
      GroupTopicService.addNewFolder(this.$route.params.groupId, newName)
        .then(res => {
          if (res.status === 201) {
            this.initFolder()
          }
        })
        .catch(err => {
          this.modalMess = this.$t('common.message.uncatch_error') as string
          this.$bvModal.show('modal-error')
        })
        .finally(() => this.$blockui.hide())
    }
  }

  /**
   * Handle rename selected folder
   * Call API rename selected folder
   */
  handleRenameFolder(newName: string) {
    if (this.roleEditTopic) {
      const folderId = this.folderEdit.value.id
      this.$blockui.show()
      GroupService.renameFolder({
        group_id: this.$route.params.groupId,
        id: folderId,
        folder_name: newName
      })
        .then(res => {
          if (res.status === 200) {
            if (this.folderEdit.value.id === this.folderSelected.value.id) {
              this.title = newName
              this.folderSelected.text = newName
              this.folderSelected.value.name = newName
            } else {
              const editFolder = this.folderOptions.find(
                item => item.id === this.folderEdit.id
              )
              if (editFolder) {
                editFolder.text = newName
                editFolder.value.name = newName
              }
            }
          }
        })
        .catch(err => {
          if (
            err.response.status === 404 &&
            err.response.data.message === ERR_API_KEY.FOLDER_NOT_FOUND
          ) {
            this.modalMess = this.$t(
              'common.message.FOLDER_NOT_EXIST'
            ) as string
            this.$bvModal.show('modal-error')
          }
        })
        .finally(() => this.$blockui.hide())
    }
  }

  /**
   * Handle delete selected folder
   * Call API delete selected folder
   */
  handleDeleteFolder() {
    if (this.roleEditTopic) {
      this.$blockui.show()
      GroupService.deleteFolder({
        group_id: this.$route.params.groupId,
        folder_id: this.folderEdit.value.id,
        type: EFolderType.TOPIC
      })
        .then(res => {
          if (res.status === 200) {
            this.modalMess = this.$t('common.message.deleted') as string
            this.$bvModal.show('modal-success')
            this.initFolder()
          }
        })
        .catch(err => {
          if (
            err.response.status === 404 &&
            err.response.data.message === ERR_API_KEY.FOLDER_NOT_FOUND
          ) {
            this.modalMess = this.$t(
              'common.message.FOLDER_NOT_EXIST'
            ) as string
            this.$bvModal.show('modal-error')
          }
        })
        .finally(() => {
          this.$blockui.hide()
        })
    }
  }

  /**
   * Handle select folder
   */
  handleSelectFolder(index: number) {
    this.folderSelected = this.folderOptions[index]
  }

  /**
   * Get selected topics
   */
  private getSelectedTopicId(): number[] {
    return this.topics.filter(item => item.checked).map(item => item.id)
  }

  private async pinDataApi(payload: PINNED_ITEM[]) {
    try {
      const res = await UserService.pinData(payload)
      if (res.status === 200) {
        const idMap = new Map(payload.map(p => [p.id, p.is_pin]))
        this.topics = this.topics.map(item =>
          idMap.has(item.id)
            ? { ...item, is_pin: idMap.get(item.id)!, checked: false }
            : item
        )
        this.checkAll = false
        this.isSelectAnyItem = false
      }
    } catch (err) {
      console.log(err)
    }
  }

  async togglePinTopicOrComment(topic: TopicCompactViewModel) {
    let payload: PINNED_ITEM[] = [
      {
        id: Number(topic.id),
        is_pin: !topic.is_pin,
        type: PIN_TYPE.TOPIC,
        groupId: this.$route.params.groupId
      }
    ]

    await this.pinDataApi(payload)
  }

  async pinMultipleTopicsOrComment() {
    let payload = this.topics
      .filter((topic) => topic.checked)
      .map(topic => ({
        id: Number(topic.id),
        is_pin: !topic.is_pin,
        type: PIN_TYPE.TOPIC,
        groupId: this.$route.params.groupId
      }))

    await this.pinDataApi(payload)
  }

  truncateText(text: string) {
    return _.truncate(text, {
      length: 50,
      separator: ' '
    })
  }
}

export class TopicCompactViewModel extends TopicCompact {
  checked: boolean = false
  is_pin: boolean = false

  // translate
  isTranslated: boolean = false
  translatedText: string = ''
  translatedTitle: string = ''

  constructor(init: TopicCompact, className?: string) {
    super()
    Object.assign(this, new TopicCompact(init, className))
  }
}

export interface IDropDown {
  id: number
  value: any
  text: string
  suffix?: string
}

export enum EState {
  ALL, // UNCLASSIFIED also = ALL
  FOLDER,
  BIN,
  DRAFT
}
